import { getNumberUnmaskStr } from 'components/FormEditReceiver/func';
import {
  ADD_BANK_ACCOUNT_HOLDER_NAME,
  BUSINESS_OF_RECEIVER_TYPE,
  EDIT_RECEIVER_COUNTRY_NAME,
  EDIT_RECEIVER_FISTNAME_NAME,
  EDIT_RECEIVER_FULLNAME_NAME,
  EDIT_RECEIVER_GENDER_NAME,
  EDIT_RECEIVER_LASTNAME_NAME,
  EDIT_RECEIVER_MOBILE_NAME,
  EDIT_RECEIVER_PHONE_NAME,
  EDIT_RECEIVER_RELATIONSHIP_NAME,
  EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME,
  RESET_EDIT_RECEIVER_INFORMATION_STORE,
} from 'constants';
import { formatter } from 'helpers';
import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import useForm from 'hooks/form/useForm';
import useReceiver from 'hooks/receiver/useReceiver';
import useGetConfig from 'hooks/useGetConfig';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import useUpdateReceiverStore from '../hooks/useUpdateReceiverStore';

const initialFormField = RESET_EDIT_RECEIVER_INFORMATION_STORE.personalDetails;

const withUpdateReceiverPersonalDetailsInitial = (Component) => {
  const UpdateReceiverPersonalDetailsInitialComponent = (props) => {
    const { countryConfig } = props || {};

    const config = useGetConfig({ countryConfig });
    const {
      mobile: mobileConfig,
      phone: phoneConfig,
      relationship: relationshipConfig,
    } = config;

    const {
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
    } = useForm(initialFormField);

    const [mobileMaskStr, setMobileMaskStr] = useState('');
    const [phoneMaskStr, setPhoneMaskStr] = useState('');
    const [eitherRequiredMsg, setEitherRequiredMsg] = useState('');

    const { currentReceiver, personalDetails, currentBusinessReceiver } =
      useFormAddReceiverStore();
    const {
      isCreateBusinessReceiver,
      isCreateIndividualReceiver,
      isReceiverOfIndividualType,
      isReceiverOfBusinessType,
    } = useReceiver();
    const { isPersonalDetailsInformationChanged, receiverTypeStore } =
      useUpdateReceiverStore();

    const { bank } = currentBusinessReceiver || {};

    const {
      firstName,
      lastName,
      mobileNumber,
      phoneNumber,
      address,
      relationship,
      fullName,
    } = currentReceiver || {};
    const { country } = address || {};

    useEffect(() => {
      if (isEmpty(currentReceiver)) return;

      if (isPersonalDetailsInformationChanged) return;

      const newInformation = {
        [EDIT_RECEIVER_COUNTRY_NAME]: country,
        [EDIT_RECEIVER_FISTNAME_NAME]: firstName,
        [EDIT_RECEIVER_LASTNAME_NAME]: lastName,
        [EDIT_RECEIVER_FULLNAME_NAME]: fullName,
        [EDIT_RECEIVER_GENDER_NAME]: '',
        [EDIT_RECEIVER_MOBILE_NAME]: mobileNumber,
        [EDIT_RECEIVER_PHONE_NAME]: phoneNumber,
        [EDIT_RECEIVER_RELATIONSHIP_NAME]: '',
        [EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME]: '',
      };
      console.log(
        `⭐ withUpdateReceiverPersonalDetailsInitial 👉 useEffect ➡️ 1 ➡️ newInformation ↩`,
        newInformation,
      );
      setInformation(newInformation);

      if (isReceiverOfIndividualType) {
        const mobileFormat = formatter.formatParse(mobileConfig?.format);
        const mobileNumberMask = formatter.mask(
          getNumberUnmaskStr(mobileNumber, mobileFormat),
          mobileFormat,
        );
        setMobileMaskStr(mobileNumberMask);
      } else {
        setMobileMaskStr('');
      }

      const phoneFormat = formatter.formatParse(phoneConfig?.format);
      const phoneNumberMask = formatter.mask(
        getNumberUnmaskStr(phoneNumber, phoneFormat),
        phoneFormat,
      );
      setPhoneMaskStr(phoneNumberMask);
    }, [
      currentReceiver,
      country,
      firstName,
      lastName,
      fullName,
      mobileNumber,
      phoneNumber,
      relationship,
      isReceiverOfIndividualType,
      isReceiverOfBusinessType,
      mobileConfig?.format,
      phoneConfig?.format,
      setInformation,
      setMobileMaskStr,
      setPhoneMaskStr,
      isPersonalDetailsInformationChanged,
    ]);

    useEffect(() => {
      if (isEmpty(personalDetails)) return;
      if (!isPersonalDetailsInformationChanged) return;

      const informationStore = personalDetails;

      console.log(
        `⭐ withUpdateReceiverPersonalDetailsInitial 👉 useEffect ➡️ 2 ➡️ newInformation ↩`,
        informationStore,
      );
      setInformation(informationStore);
    }, [personalDetails, isPersonalDetailsInformationChanged, setInformation]);

    useEffect(() => {
      if (isEmpty(currentBusinessReceiver)) return;
      if (!isCreateBusinessReceiver && !isCreateIndividualReceiver) return;

      const accountHolderName = bank?.[ADD_BANK_ACCOUNT_HOLDER_NAME] || '';
      const firstNameFromDetails =
        personalDetails?.[EDIT_RECEIVER_FISTNAME_NAME] || accountHolderName;
      const fullNameFromDetails =
        personalDetails?.[EDIT_RECEIVER_FULLNAME_NAME] || accountHolderName;

      setInformation((prevInformation) => {
        const newInformation = {
          ...initialFormField,
          ...prevInformation,
          [EDIT_RECEIVER_COUNTRY_NAME]: country,
          [EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME]: receiverTypeStore,
          [EDIT_RECEIVER_FISTNAME_NAME]: firstNameFromDetails,
          [EDIT_RECEIVER_FULLNAME_NAME]: fullNameFromDetails,
          [EDIT_RECEIVER_LASTNAME_NAME]: isCreateIndividualReceiver
            ? personalDetails?.[EDIT_RECEIVER_LASTNAME_NAME] || ''
            : prevInformation?.[EDIT_RECEIVER_LASTNAME_NAME],
          [EDIT_RECEIVER_GENDER_NAME]: isCreateBusinessReceiver
            ? BUSINESS_OF_RECEIVER_TYPE
            : '',
        };
        console.log(
          `⭐ withUpdateReceiverPersonalDetailsInitial 👉 useEffect ➡️ 3 ➡️ newInformation ↩`,
          newInformation,
        );
        return newInformation;
      });
    }, [
      isCreateBusinessReceiver,
      isCreateIndividualReceiver,
      currentBusinessReceiver,
      personalDetails,
      bank,
      country,
      setInformation,
      receiverTypeStore,
    ]);

    const newProps = {
      ...props,
      information,
      setInformation,
      validation,
      setValidation,
      checkAllowSubmit,
      mobileMaskStr,
      setMobileMaskStr,
      phoneMaskStr,
      setPhoneMaskStr,
      eitherRequiredMsg,
      setEitherRequiredMsg,
      mobileConfig,
      phoneConfig,
      relationshipConfig,
    };
    return <Component {...newProps} />;
  };
  return UpdateReceiverPersonalDetailsInitialComponent;
};

export default withUpdateReceiverPersonalDetailsInitial;
